import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import QuickLRU from 'quick-lru';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  cache = new QuickLRU({
    maxSize: 50,
    maxAge: 1000 * 60 * 5,
  });

  constructor(private http: HttpClient) { }

  public get<T>(url: string): Observable<T> {
    const cached = this.cache.get(url);
    if (cached === undefined) {
      const request = this.http.get<T>(url).pipe(shareReplay(1));
      this.cache.set(url, request);
      return request;
    }
    return cached as Observable<T>;
  }
}
